/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useSelector } from "react-redux";

export const useSelectedCategory = () =>
  useSelector((state) => state.products.selectedCategory);
